module.exports = {"data":{"site":{"siteMetadata":{"title":"Citizen Sustainability Certificate"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 110
// module chunks = 60335399758886 114276838955818